import React, { useContext, useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { StoreContext } from '../contexts/StoreContext';
import { FONT_HEADLINE, FONT_TITLE2, FONT_BODY } from '../constants/typography';
import { BORDER_RADIUS, SPACING_BUTTON, SPACING_CARD, SPACING_GROUP } from '../constants/layout';

export default function MaintenanceView({ message }) {
  const { store } = useContext(StoreContext);
  const [logoURL, setLogoURL] = useState(null);

  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, 'navigation_bar_preferences', 'default'),
      snap => {
        if (snap.exists()) {
          setLogoURL(snap.data()?.logo_url || null);
        }
      }
    );
    return () => unsub();
  }, []);

  const displayMessage = message && message.trim()
    ? message
    : "We're making updates to the store. Check back soon.";
  const storeName = store?.name || '';

  return (
    <div className="maintenance-page">
      {(logoURL || storeName) && (
        <div className="maintenance-header">
          {logoURL ? (
            <img src={logoURL} alt={storeName} className="maintenance-logo" />
          ) : (
            <div className="maintenance-store-name">{storeName}</div>
          )}
        </div>
      )}
      <div className="maintenance-content">
        <span className="material-icons maintenance-icon">construction</span>
        <h1 className="maintenance-title">Be Right Back</h1>
        <p className="maintenance-message">{displayMessage}</p>
      </div>
      <style>{`
        .maintenance-page {
          display: flex;
          flex-direction: column;
          align-items: center;
          min-height: 100vh;
          background: var(--color-background, #f5f5f5);
          padding: ${SPACING_GROUP};
        }
        .maintenance-header { padding-top: ${SPACING_GROUP}; }
        .maintenance-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          max-width: 480px;
        }
        .maintenance-logo {
          height: 48px;
          width: auto;
          object-fit: contain;
          border-radius: ${BORDER_RADIUS};
        }
        .maintenance-store-name {
          font-size: ${FONT_HEADLINE};
          font-weight: 600;
          color: var(--color-text-primary, #111827);
        }
        .maintenance-icon {
          font-size: 48px;
          color: var(--color-text-secondary, #6b7280);
          margin-bottom: ${SPACING_CARD};
        }
        .maintenance-title {
          font-size: ${FONT_TITLE2};
          font-weight: 700;
          color: var(--color-text-primary, #111827);
          margin: 0 0 ${SPACING_BUTTON} 0;
        }
        .maintenance-message {
          font-size: ${FONT_BODY};
          color: var(--color-text-secondary, #6b7280);
          line-height: 1.5;
          margin: 0;
        }
      `}</style>
    </div>
  );
}
